export const SET_PROJECT_STATUS = 'SET_PROJECT_STATUS';

export const setAllStatusProject = (status) => ({
  type: SET_PROJECT_STATUS,
  payload: status,
});
